import { UsersService } from './../../services/UsersService';
import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoundAndClinicService } from 'src/app/services/RoundAndClinicService';
import { RoundAndClinicModel } from 'src/app/models/RoundAndClinicModel';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { UsersModel } from 'src/app/models/UsersModel';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-roundandclinic-search',
  templateUrl: './roundandclinic-search.component.html',
  styleUrls: ['./roundandclinic-search.component.css']
})
export class RoundandclinicSearchComponent implements OnInit {
patientcode = '';
  note = '';
  Laboratory = '';
  Toxicity = '';
  Nutrition = '';
  Response = '';
  DrugInteractions = '';
  Hypersensitive = '';
  PatientEducation = '';
  notetype = '';
  date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  extra = '';
  userid = '';
  compcode = '';
  config: AngularEditorConfig;
  roundandclinic: RoundAndClinicModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();
  constructor(
    public RoundAndClinicService: RoundAndClinicService,
    public RoundsAndClinics: RoundAndClinicModel,
    public users: UsersModel,
    public UsersService: UsersService,
    public dialogRef: MatDialogRef<RoundandclinicSearchComponent>,
    public storage: LocalStorageService,
    public RoundSelectedData: RoundAndClinicModel,
    @Inject(MAT_DIALOG_DATA)
     public data: any
  ) {}

  ngOnInit(): void {
    this.retriveRoundAndClinicsTop();
  }

retriveRoundAndClinicsTop() {
    this.roundandclinic = [];
    this.RoundAndClinicService.Getroundandclinic(
      this.storage.retrieve('stgPatientCode')
    ).subscribe((data: RoundAndClinicModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.roundandclinic[i] = data[i];
        this.roundandclinic[i].notetype = data[i].notetype;
        this.roundandclinic[i].note = data[i].note;
        this.roundandclinic[i].date = formatDate(
          data[i].date,
          'yyyy-MM-dd',
          'en'
        );
        this.roundandclinic[i].extra = data[i].extra;
      }
    });
  }


Selectroundandclinic(roundandclinic: RoundAndClinicModel) {
  if( roundandclinic.extra !== this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8'){return this.MesgWarrning()}

  this.RoundSelectedData.patientcode = roundandclinic.patientcode;
  this.RoundSelectedData.notetype = roundandclinic.notetype;
  this.RoundSelectedData.note = roundandclinic.note;
  this.RoundSelectedData.date = roundandclinic.date;
  this.RoundSelectedData.extra = roundandclinic.extra;
  this.RoundSelectedData.userid = roundandclinic.userid;
  this.RoundSelectedData.compcode = roundandclinic.compcode;
  this.dialogRef.close(this.RoundSelectedData);
}

  getColorClass(notetybe: string) {
    if (notetybe == 'Hypersensitive') return 'red-bg';
    return '';
  }

DeleteRounds (){
  this.RoundAndClinicService.DeleteRounds(this.storage.retrieve('stgPatientCode'),this.storage.retrieve('stgNoteType'),this.storage.retrieve('stguserid'),this.storage.retrieve('stgVisitDate')).subscribe((data: RoundAndClinicModel)=>{
  this.retriveRoundAndClinicsTop();
  });
  this.retriveRoundAndClinicsTop();
}
      MesgWarrning(){

        Swal({
          title: 'Check User',
          text:'Editing or deleting this medical record  is not allowed ',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          //cancelButtonText: 'No, keep it',
        })
        ;

      }
MessegeDelete(Rounds :RoundAndClinicModel){
  debugger;
    if( Rounds.extra == this.storage.retrieve('stgusername'))
      {
      Swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.storage.store('stgPatientCode',Rounds.patientcode);
          this.storage.store('stgVisitDate',Rounds.date);
          this.storage.store('stgNoteType',Rounds.notetype)
          this.storage.store('stguserid',Rounds.userid)

          this.DeleteRounds();
          Swal('Deleted!', 'Your record has been deleted.', 'success');
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            Swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );
      }
      else
      { this.MesgWarrning()}
    }

}

